import { Typography, Box } from "@mui/material";
import PageHeader from "../../components/common/PageHeader";

export default function AccountingDashboard() {

  return (
    <Box className="page">

      <PageHeader title="Accounting Dashboard" />

      <Typography variant="h6">
        Accounting overview will appear here.
      </Typography>

    </Box>
  );
}